import { css } from 'styled-components';

export const size = {
  handheld: '420px',
  mobile: '600px',
  tablet: '800px',
  laptop: '1000px',
  desktop: '1000px'
}

export const media = {
    handheld: (...args) => css`
      @media (max-width: ${size.handheld}) {
        ${ css(...args) }
      }
    `,

    mobile: (...args) => css`
      @media (max-width: ${size.mobile}) {
        ${ css(...args) }
      }
    `,

    tablet: (...args) => css`
      @media (max-width: ${size.tablet}) {
        ${ css(...args) }
      }
    `,

    laptop: (...args) => css`
      @media (max-width: ${size.laptop}) {
        ${ css(...args) }
      }
    `,

    desktop: (...args) => css`
      @media (max-width: ${size.desktop}) {
        ${ css(...args) }
      }
    `
  }


// WEBPACK FOOTER //
// ./src/utilities/style-utilities.js